import { useNavigate } from 'react-router-dom';
import PerfilModal from './PerfilModal';
import Menu from '../components/Menu';

import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
// Silueta por defecto
const DEFAULT_AVATAR = 'https://cdn-icons-png.flaticon.com/512/149/149071.png';
// Ruta base para logotemas (ajusta según tu backend)
const LOGOTEMA_BASE_URL = 'https://tuservidor.com/uploads/logotemas/';

export default function PacienteDashboard({ token, userId, setTratamientos }) {
  const navigate = useNavigate();
  const [perfil, setPerfil] = useState(null);
    const [tratamientos, setTratamientosLocal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPerfil, setShowPerfil] = useState(false);
  const [perfilLoading, setPerfilLoading] = useState(false);

  useEffect(() => {
    // Cargar perfil del paciente
    fetch(`${API_URL}/usuarios/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setPerfil(data);
        // Cargar tratamientos asignados usando el nuevo endpoint
        fetch(`${API_URL}/usuarios/${userId}/tratamientos`, {
          headers: { Authorization: `Bearer ${token}` }
        })
          .then(res => res.json())
          .then(trats => {
            setTratamientosLocal(trats);
            setTratamientos && setTratamientos(trats);
            // Guardar en localStorage para InfoScreenWrapper
            localStorage.setItem('tratamientos', JSON.stringify(trats));
          })
          .finally(() => setLoading(false));
      });
  }, [token, userId]);

  // Guardar perfil completo
  const handleSavePerfil = async ({ nombre, avatar, nota, privada }) => {
    setPerfilLoading(true);
    try {
  const res = await fetch(`${API_URL}/usuarios/${userId}/perfil`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ nombre, avatar, notas: nota, notas_privadas: privada })
      });
      if (res.ok) {
        setPerfil(prev => ({ ...prev, nombre, avatar, notas: nota, notas_privadas: privada }));
        setShowPerfil(false);
      }
    } catch (e) {}
    setPerfilLoading(false);
  };

  if (loading) return <div>Cargando...</div>;
  if (!perfil) return <div>Error cargando perfil</div>;

  // Logotema del primer tratamiento (si existe)
  const logotemaTratamiento = tratamientos[0]?.carpeta ? `/Tratamientos/${tratamientos[0].carpeta}/logotema.png` : undefined;
  return (
    <div className="paciente-dashboard">
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 20, padding: '8px 0 0 8px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
          <img
            src={perfil.avatar || DEFAULT_AVATAR}
            alt="Avatar"
            style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover', border: '2px solid #0099cc', marginBottom: 6, boxShadow: '0 2px 8px rgba(0,153,204,0.08)' }}
          />
          <h2 style={{ fontSize: 17, margin: 0, marginBottom: 2, color: '#222', fontWeight: 700, letterSpacing: 0.2 }}>{perfil.nombre}</h2>
          <button className="btn" style={{ marginBottom: 6, fontSize: 13, padding: '6px 14px', background: '#0099cc', color: '#fff', borderRadius: 8, border: 'none', fontWeight: 600, boxShadow: '0 1px 4px rgba(0,153,204,0.08)' }} onClick={() => setShowPerfil(true)}>
            Editar perfil y notas
          </button>
          {showPerfil && (
            <PerfilModal
              initialNombre={perfil.nombre}
              initialAvatar={perfil.avatar}
              initialNota={perfil.notas}
              initialPrivacidad={perfil.notas_privadas}
              onSave={handleSavePerfil}
              onClose={() => setShowPerfil(false)}
              loading={perfilLoading}
              mobile={true}
            />
          )}
        </div>
      </div>
      {/* Menú con botones de tratamientos y acciones solo en dashboard */}
      <Menu
        tratamientos={tratamientos}
        isLoggedIn={true}
        onLogout={() => { window.location.href = '/login'; }}
        onInfo={id => navigate(`/info?id=${id}`)}
        onComoFunciona={() => navigate('/como-funciona')}
        onRelajacion={() => navigate('/relajacion')}
        onSonoTerapia={() => navigate('/sonoterapia')}
        onTratamiento={id => navigate(`/tratamiento/${id}`)}
        onFaq={() => {}}
        onAcerca={() => {}}
        onContacta={() => {}}
        logotema={logotemaTratamiento}
      />
    </div>
  );
}
